import template from './acris-faq-document-form.html.twig';
import './acris-faq-document-form.scss';

const { Component, Mixin } = Shopware;

Component.register('acris-faq-document-form', {
    template,
    inject: ['repositoryFactory'],

    emits: ['media-open'],

    mixins: [
        Mixin.getByName('notification')
    ],

    props: {
        faq: {
            type: Object,
            required: true,
            default: null
        },

        refs: {
            type: Object,
            required: false,
            default: null
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false
        },

        isInherited: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            isMediaLoading: false,
            columnCount: 7,
            acrisUploadTag: 'acrisFaqUploadTag',
            columnWidth: 90,
            displayEditDocument: false,
            editDocumentItem: null
        };
    },

    computed: {
        documentItems() {
            const documentItems = this.faqDocuments.slice();
            const placeholderCount = this.getPlaceholderCount(this.columnCount);

            if (placeholderCount === 0) {
                return documentItems;
            }

            for (let i = 0; i < placeholderCount; i += 1) {
                documentItems.push(this.createPlaceholderMedia(documentItems));
            }
            return documentItems;
        },

        isLoading() {
            return this.isMediaLoading;
        },

        faqDocumentsRepository() {
            return this.repositoryFactory.create('acris_faq_document');
        },

        faqDocuments() {
            if (!this.faq) {
                return [];
            }
            return this.faq.acrisFaqDocuments;
        },

        gridAutoRows() {
            return `grid-auto-rows: ${this.columnWidth}`;
        },

        displayEditDocument(displayEditDocument) {
            if (!displayEditDocument) displayEditDocument = this.displayEditDocument;
            return true;
        },

        faqDocumentsEntityName() {
            return 'acris_faq_document';
        }
    },

    methods: {
        onOpenMedia() {
            this.$emit('media-open');
        },

        updateColumnCount() {
            this.$nextTick(() => {
                if (this.isLoading) {
                    return false;
                }

                const cssColumns = window.getComputedStyle(this.$refs.grid, null)
                    .getPropertyValue('grid-template-columns')
                    .split(' ');
                this.columnCount = cssColumns.length;
                this.columnWidth = cssColumns[0];

                return true;
            });
        },

        getPlaceholderCount(columnCount) {
            if (this.faqDocuments.length + 3 < columnCount * 2) {
                columnCount *= 2;
            }

            let placeholderCount = columnCount;

            if (this.faqDocuments.length !== 0) {
                placeholderCount = columnCount - ((this.faqDocuments.length) % columnCount);
                if (placeholderCount === columnCount) {
                    return 0;
                }
            }

            return placeholderCount;
        },

        createPlaceholderMedia(documentItems) {
            return {
                isPlaceholder: true,
                media: {
                    isPlaceholder: true,
                    name: ''
                },
                mediaId: documentItems.length.toString()
            };
        },

        successfulUpload({ targetId }) {
            // on replace
            if (this.faq.acrisFaqDocuments.find((faqDocuments) => faqDocuments.mediaId === targetId)) {
                return;
            }

            const faqDocuments = this.createDocumentAssociation(targetId);
            this.faq.acrisFaqDocuments.add(faqDocuments);
        },

        createDocumentAssociation(targetId) {
            const faqDocuments = this.faqDocumentsRepository.create(Shopware.Context.api);

            faqDocuments.faqId = this.faq.id;
            faqDocuments.mediaId = targetId;

            if (this.faq.acrisFaqDocuments.length <= 0) {
                faqDocuments.position = 0;
            } else {
                faqDocuments.position = this.faq.acrisFaqDocuments.length;
            }
            return faqDocuments;
        },

        onUploadFailed(uploadTask) {
            const toRemove = this.faq.acrisFaqDocuments.find((faqDocuments) => {
                return faqDocuments.mediaId === uploadTask.targetId;
            });
            if (toRemove) {
                this.faq.acrisFaqDocuments.remove(toRemove.id);
            }
        },

        removeFile(documentItem) {
            this.faq.acrisFaqDocuments.remove(documentItem.id);
        },

        editFile(documentItem) {
            this.editDocumentItem = documentItem;
            this.displayEditDocument = true;
        },

        onEditDocumentSave(documentItem) {
            let editedDocumentItem = this.faq.acrisFaqDocuments.find((faqDocuments) => faqDocuments.id === documentItem.id);
            editedDocumentItem = documentItem;
            this.displayEditDocument = false;
        },

        onEditDocumentClose() {
            this.displayEditDocument = false;
        },

        onDropDocument(dragData) {
            if (this.faq.acrisFaqDocuments.find((faqDocuments) => faqDocuments.mediaId === dragData.id)) {
                return;
            }

            const faqDocuments = this.createDocumentAssociation(dragData.mediaItem.id);

            this.faq.acrisFaqDocuments.add(faqDocuments);
        },

        onDocumentItemDragSort(dragData, dropData, validDrop) {
            if (validDrop !== true) {
                return;
            }
            this.faq.acrisFaqDocuments.moveItem(dragData.position, dropData.position);

            this.updateDocumentItemPositions();
        },

        updateDocumentItemPositions() {
            this.faqDocuments.forEach((medium, index) => {
                medium.position = index;
            });
        }
    }
});
